var map = {
	"./icon-add.svg": 68869,
	"./icon-copy.svg": 54171,
	"./icon-history.svg": 85292,
	"./icon-invite.svg": 49855,
	"./icon-leaders.svg": 34296,
	"./icon-main.svg": 53079,
	"./icon-ok.svg": 35686,
	"./icon-per.svg": 94701,
	"./icon-refresh.svg": 82037,
	"./icon-share.svg": 71820,
	"./icon-tasks.svg": 48199,
	"./icon-telegram.svg": 45810,
	"./icon-time.svg": 94375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;